import APP_VERSION from '../version';

/* Provera verzije: poredi APP_VERSION iz bundla sa public/meta.json na serveru (fetch bez keša).
   Ako se razlikuju — novi deploy — briše Cache Storage i učitava stranu ponovo sa ?v=<verzija>, pa browser ne sme
   da posluži keširan index.html. localStorage se NE briše: u njemu su samo token, korisnik i podešavanja (tema, meni).
   Vraća true ako je pokrenut reload. Samo u produkciji (u dev-u meta.json nije pouzdan). */
export default async function checkVersion() {
    if (process.env.NODE_ENV !== 'production') return false;
    try {
        const res = await fetch(`${process.env.PUBLIC_URL || ''}/meta.json?ts=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return false;
        const meta = await res.json();
        if (!meta || !meta.version || meta.version === APP_VERSION) return false;

        /* zaštita od petlje ako proxy/CDN i dalje služi stari bundle */
        if (sessionStorage.getItem('versionReloadDone') === meta.version) return false;
        sessionStorage.setItem('versionReloadDone', meta.version);

        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
        }
        window.location.replace(`${window.location.pathname}?v=${encodeURIComponent(meta.version)}`);
        return true;
    } catch {
        return false; // meta.json nedostupan — ne blokira aplikaciju
    }
}
